module.exports = __webpack_public_path__ + "static/img/11-人大附中翠微学校1.4bfc78e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/11-人大附中翠微学校1.png
// module id = i1UU
// module chunks = 0